export type Holiday = {
  name: string
  longName: string
  color: string
}

export const HOLIDAYS: { [key: string]: Holiday } = {
  '04-13': { name: 'Palm', longName: 'Palm Sunday', color: '#A9CB54' },
  '04-18': { name: 'Good', longName: 'Good Friday', color: '#4DA0CC' },
  '04-20': { name: 'Easter', longName: 'Easter', color: '#B57FDE' },
  '12-14': { name: 'Hanukkah', longName: 'Hanukkah', color: '#4DA0CC' },
  '12-24': { name: 'Christmas Eve', longName: 'Christmas Eve', color: '#8AA643' },
  '12-25': { name: 'Christmas Day', longName: 'Christmas Day', color: '#C86666' },
  '12-31': { name: "New Year's Eve", longName: "New Year's Eve", color: '#DCAE6F' },
  '01-01': { name: "New Year's Day", longName: "New Year's Day", color: '#B57FDE' },
}
